import React from "react";
import PropTypes from "prop-types";
// Material imports
import withStyles from "@mui/styles/withStyles";
import Fade from "@mui/material/Fade";
const SlideImage = ({
  classes,
  imgSrc,
  primaryColour,
  shouldAnimate,
  roundImage = false
}) => {
  return /*#__PURE__*/React.createElement(Fade, {
    in: true,
    timeout: 500,
    style: {
      transitionDelay: "0.4s"
    },
    appear: shouldAnimate
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.imgContainer,
    style: {
      backgroundColor: primaryColour
    }
  }, /*#__PURE__*/React.createElement("img", {
    src: imgSrc,
    alt: "slideImg",
    className: roundImage ? classes.round : classes.img
  })));
};
const styles = {
  imgContainer: {
    justifyContent: "center",
    display: "flex",
    flex: "1",
    alignItems: "center",
    overflow: "auto"
  },
  img: {
    maxWidth: 320,
    maxHeight: "100%"
  },
  round: {
    maxWidth: 150,
    maxHeight: "100%",
    borderRadius: "50%"
  }
};
export default withStyles(styles)(SlideImage);
SlideImage.propTypes = {
  classes: PropTypes.object.isRequired,
  shouldAnimate: PropTypes.bool,
  imgSrc: PropTypes.string.isRequired,
  primaryColour: PropTypes.string.isRequired,
  roundImage: PropTypes.bool
};